import React from 'react';

const Home: React.FC = () => {
  return (
    <div className="container mx-auto p-4">
      <h1 className="text-2xl font-bold mb-4 text-center">Welcome to MyApp</h1>
      <p className="text-center">This is the home page.</p>
    </div>
  );
};

export default Home;